import React, { useState, useEffect } from 'react';
import { Container, Card, Table, Form, Row, Col, Alert, Button, Modal } from 'react-bootstrap';
import { firestore } from "../../firebase";
import { Link, useHistory, useParams } from 'react-router-dom';
import { FaEdit, FaTrashAlt } from 'react-icons/fa'
import { CSVLink } from 'react-csv';

export default function ViewSale() {
    const { id } = useParams();
    const history = useHistory();
    const [effect, setEffect] = useState(0);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [editing, setEditing] = useState(false);
    const [confirmada, setConfirmada] = useState(false);
    const [vendedores, setVendedores] = useState([]);
    const [clientes, setClientes] = useState([]);
    const [fecha, setFecha] = useState("");
    const [codigo, setCodigo] = useState(0);
    const [vendedor, setVendedor] = useState("");
    const [cliente, setCliente] = useState("");
    const [metodoPago, setMetodoPago] = useState("");
    const [notas, setNotas] = useState("");
    const [precioCRC, setPrecioCRC] = useState(0);
    const [precioUSD, setPrecioUSD] = useState(0);
    const [productos, setProductos] = useState([]);
    const [showConfirmAlert, setShowConfirmAlert] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [dataCSV, setDataCSV] = useState([['SEP=,'], ['ocurrió un error, vuelva a descargar el archivo']]);

    async function getSale() {
        setLoading(true);
        setError("");

        const ventasQuery = firestore.collection('ventas').doc(id);
        ventasQuery.onSnapshot(async (querySnapshot) => {
            if (!querySnapshot.exists) {
                setError("La venta no existe");
            } else {
                const data = querySnapshot.data();
                let date = new Date(data.fecha.toDate());
                date = date.toLocaleDateString('es-ES', {
                    weekday: 'long', 
                    year: 'numeric', 
                    month: 'long', 
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric'
                });

                const items = []

                for (let i in data.productos.ids) {
                    const pdoc = await firestore.collection('productos').doc(data.productos.ids[i]).get();
                    const productData = pdoc.data();
                    const cant = data.productos.cantidades[i];

                    items.push({
                        id: pdoc.id,
                        codigo: productData.codigo,
                        descripcion: productData.descripcion,
                        cantidad: cant,
                        divisa: productData.precio.divisa,
                        precio: productData.precio.cantidad
                    })
                }

                setCodigo(data.codigo);
                setFecha(date);
                setVendedor(data.vendedor.id);
                setCliente(data.cliente.id);
                setMetodoPago(data.metodo_pago);
                setNotas(data.notas);
                setConfirmada(data.confirmada);

                setProductos(items);
                setLoading(true);
                setError("");
        
                if (data.confirmada) {
                    const newCSV = [];
                    newCSV.push(['Orden de Compra', 'ProVell Soluciones Médicas']);
                    newCSV.push([]);
                    newCSV.push(['Código:', data.codigo]);
                    newCSV.push(['Fecha:', date]);
                    newCSV.push(['Cliente:', data.cliente.nombre]);
                    newCSV.push(['Vendedor:', data.vendedor.nombre]);
                    newCSV.push(['Método de Pago:', data.metodo_pago]);
                    newCSV.push([]);
                    newCSV.push(['Código', 'Producto', 'Cantidad', 'Divisa', 'Precio']);

                    let crc = 0;
                    let usd = 0;

                    for (const i in items) {
                        const pid = items[i].id;
                        const pdoc = await firestore.collection('productos').doc(pid).get();
                        const pdata = pdoc.data();

                        if (pdata.precio.divisa === 'CRC') {
                            crc = crc + pdata.precio.cantidad * items[i].cantidad;
                        } else if (pdata.precio.divisa === 'USD') {
                            usd = usd + pdata.precio.cantidad * items[i].cantidad
                        }
        
                        const precio = new Intl.NumberFormat('en-US', {
                            style: 'currency',
                            currency: 'USD'
                        }).format(pdata.precio.cantidad);
        
                        newCSV.push([pdata.codigo, pdata.descripcion, items[i].cantidad, pdata.precio.divisa, precio.substring(1)]);
                    }
                    newCSV.push([]);

                    crc = new Intl.NumberFormat('en-US', {
                        style: 'currency',
                        currency: 'USD'
                    }).format(crc);


                    usd = new Intl.NumberFormat('en-US', {
                        style: 'currency',
                        currency: 'USD'
                    }).format(usd);

                    newCSV.push(['Total CRC:', crc.substring(1)]);
                    newCSV.push(['Total USD:', usd.substring(1)]);
        
                    setDataCSV(newCSV);
                }
                
                setLoading(false);
            }
        })
    }

    function getVendedores() {
        setLoading(true);
        setError("");

        const vendedoresQuery = firestore.collection('vendedores').orderBy("codigo", "asc")
        vendedoresQuery.onSnapshot(querySnapshot => {
            const items = [];
            querySnapshot.forEach(doc => {
                const data = doc.data();
                items.push({
                    id: doc.id,
                    codigo: data.codigo,
                    nombre: data.nombre
                })
            })
            setVendedores(items);
            setLoading(false);
        })        
    }

    function getClientes() {
        setLoading(true);
        setError("");

        const clientesQuery = firestore.collection('clientes').orderBy("nombre", "asc");
        clientesQuery.onSnapshot(querySnapshot => {
            const items = [];
            querySnapshot.forEach(doc => {
                const data = doc.data();
                items.push({
                    id: doc.id,
                    nombre: data.nombre
                })
            })
            setClientes(items);
            setLoading(false);
        })        
    }

    function updatePrices() {
        setLoading(true);

        let crc = 0;
        let usd = 0;

        productos.forEach(p => {
            if (p.divisa === 'CRC') {
                crc = crc + p.precio * p.cantidad;
            } else if (p.divisa === 'USD') {
                usd = usd + p.precio * p.cantidad
            }
        })

        setPrecioCRC(crc);
        setPrecioUSD(usd);

        setLoading(false);
    }

    async function handleSubmit(e) {
        e.preventDefault();
        setLoading(true);
        setError("");

        if (!vendedor || !cliente || !metodoPago) {
                setError("Uno o más campos requeridos no llenados");
                setLoading(false);
                return null;
            }

        const editProductos = productos;
        const editVendedor = vendedor;
        const editCliente = cliente;
        const editMetodoPago = metodoPago;
        const editNotas = notas;

        const objVendedor = vendedores.find(elem => elem.id === editVendedor);
        const objCliente = clientes.find(elem => elem.id === editCliente);

        const newIds = [];
        const newCantidades = [];

        async function findOldProductQuantity(idSaved) {
            const doc = await firestore.collection('ventas').doc(id).get();
            const productos = doc.data().productos;
            for (const p in productos.ids) {
                if (productos.ids[p] === idSaved) 
                    return productos.cantidades[p];
            }
            return -1;
        }

        for (const p in editProductos) {

            const oldProductQuantity = await findOldProductQuantity(editProductos[p].id);

            if (oldProductQuantity !== -1) {
                const currentProduct = await firestore.collection('productos').doc(editProductos[p].id).get();

                if (currentProduct.data().cantidad.actual < editProductos[p].cantidad - oldProductQuantity) {
                        setError("La cantidad de venta de uno o más productos supera a " + 
                            "la cantidad actual en inventario del producto");
                        setLoading(false);
                        return null;
                    }
            }

            newIds.push(editProductos[p].id);
            newCantidades.push(Number(editProductos[p].cantidad));
        }

        firestore.collection('ventas').doc(id).update({
            productos: {
                ids: newIds,
                cantidades: newCantidades
            },
            vendedor: {
                id: objVendedor.id,
                nombre: objVendedor.nombre
            },
            cliente: {
                id: objCliente.id,
                nombre: objCliente.nombre
            },
            metodo_pago: editMetodoPago,
            notas: editNotas
        }).then(() => {
            setShowEdit(true);
            setEditing(false);
            setEffect(effect+1);
            setLoading(false);
        }).catch(() => {
            setError('Ocurrió un error inesperado, vuélvalo a intentar más tarde');
            setLoading(false);
        })

    }

    function handleDelete(e) {
        e.preventDefault();
        setLoading(true);
        setError("");

        firestore.collection('ventas').doc(id).delete()
        .then(() => {
            setShowDelete(false);
            setLoading(false);
            history.push("/sales");
        })
        .catch(() => {
            setError('Ocurrió un error inesperado, vuélvalo a intentar más tarde');
            setShowDelete(false);
            setLoading(false);
        })
    }

    function confirmSale(e) {
        e.preventDefault();
        setLoading(true);
        setError("");
        setShowConfirmAlert(false);
        
        firestore.collection('ventas').doc(id).update({ confirmada: true, fecha: new Date() })
        .then(() => {
            setConfirmada(true);
            setEffect(effect+1);
            setLoading(false);
        })
        .catch(() => {
            setError("Ocurrió un error inesperado, vuélvalo a intentar más tarde");
            setLoading(false);
        })
    }

    useEffect(() => {
        getVendedores();
        getClientes();
        getSale();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [effect])

    useEffect(() => {
        updatePrices();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [productos])

    return (
        <Container 
        className="d-flex align-items-center justify-content-center"
        >
            <div className="w-100" style = {{ maxWidth: "550px"}}>
                <h2 className="text-center mt-3 mb-4">Ver Venta</h2>
                <Modal show={showEdit} onHide={() => setShowEdit(false)}>
                    <Modal.Header>
                        <Modal.Title>Éxito</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Se editó la venta correctamente.
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={() => setShowEdit(false)}>
                            Regresar
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal show={showConfirmAlert} onHide={() => setShowConfirmAlert(false)}>
                    <Modal.Header>
                        <Modal.Title>Aviso</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        ¿Desea confirmar la venta? No podrá volver a editar ninguno de sus datos.
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={confirmSale}>
                            Aceptar
                        </Button>
                        <Button variant="secondary" onClick={() => setShowConfirmAlert(false)}>
                            Cancelar
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal show={showDelete} onHide={() => setShowDelete(false)}>
                    <Modal.Header>
                        <Modal.Title>Aviso</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        ¿Desea borrar la venta? Desaparecerá del sistema completamente.
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="danger" onClick={handleDelete}>
                            Aceptar
                        </Button>
                        <Button variant="secondary" onClick={() => setShowDelete(false)}>
                            Cancelar
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Card>
                    <Card.Body>
                        {error && <Alert variant="danger">{error}</Alert>}
                        <Form onSubmit={handleSubmit}>
                            <Row className="m-2">
                                <Form.Group className="mb-3" id="venta-id">
                                    <Form.Label>Código</Form.Label>
                                    <Form.Control 
                                    type="text" 
                                    value={codigo}
                                    disabled={true}/>
                                </Form.Group>
                            </Row>
                            <Row className="m-2">
                                <Form.Group className="mb-3" id="venta-fecha">
                                    <Form.Label>Fecha</Form.Label>
                                    <Form.Control 
                                    type="text" 
                                    value={fecha}
                                    onChange={e => setFecha(e.target.value)}
                                    disabled={true}/>
                                </Form.Group>
                            </Row>
                            <Row className="m-2">
                                <Col xs={12}>
                                    <Form.Group className="mb-3" id="venta-select-vendedor">
                                        <Form.Label>Vendedor</Form.Label>{' '}
                                        <Form.Control
                                        as="select" custom
                                        value={vendedor}
                                        onChange={e => setVendedor(e.target.value)}
                                        disabled={loading || !editing}
                                        >
                                            <option value="">Escoja un vendedor</option>
                                            {vendedores 
                                            && vendedores.map(v => {
                                                return (
                                                    <option key={v.id} value={v.id}>{`${v.codigo} - ${v.nombre}`}</option>
                                                )
                                            })}
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col xs={12}>
                                    <Form.Group className="mb-3" id="venta-select-cliente">
                                        <Form.Label>Cliente</Form.Label>{' '}
                                        <Form.Control
                                        as="select" custom
                                        value={cliente}
                                        onChange={e => setCliente(e.target.value)}
                                        disabled={loading || !editing}
                                        >
                                            <option value="">Escoja un cliente</option>
                                            {clientes 
                                            && clientes.map(c => {
                                                return (
                                                    <option key={c.id} value={c.id}>{c.nombre}</option>
                                                )
                                            })}
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="m-2">
                                <Col xs={12}>
                                    <Form.Group className="mb-3" id="venta-select-metodoPago">
                                        <Form.Label>Método de Pago</Form.Label>{' '}
                                        <Form.Control
                                        as="select" custom
                                        value={metodoPago}
                                        onChange={e => setMetodoPago(e.target.value)}
                                        disabled={loading || !editing}
                                        >
                                            <option value="">Escoja un método de pago</option>
                                            <option value="Efectivo">Efectivo</option>
                                            <option value="Datafono">Datáfono</option>
                                            <option value="Transferencia">Transferencia</option>
                                            <option value="Sinpe Movil">Sinpe Móvil</option>
                                            <option value="Otro">Otro</option>
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="m-2">
                                <Form.Group className="mb-3" id="venta-notas">
                                    <Form.Label>Notas (opcional)</Form.Label>
                                    <Form.Control 
                                    as="textarea" rows={3}
                                    value={notas}
                                    onChange={e => setNotas(e.target.value)}
                                    disabled={loading || !editing}/>
                                </Form.Group>
                            </Row>
                            <h4>Productos</h4>
                            <Table responsive striped bordered className='m-auto'>
                                <thead>
                                    <tr>
                                        <th>Código</th>
                                        <th>Descripción</th>
                                        <th>Cantidad</th>
                                        <th>Eliminar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {productos &&
                                    productos.map((p, index) => {
                                        return (
                                            <tr key={p.id}>
                                                <td>
                                                    <Link to={`/products/view_${p.id}`}>
                                                        {p.codigo}
                                                    </Link>
                                                </td>
                                                <td>{p.descripcion}</td>
                                                <td>
                                                    <Form.Group className="mb-3" id={`venta-cantidad-${p.id}`}>
                                                        <Form.Control 
                                                        type="number" 
                                                        value={p.cantidad}
                                                        onChange={e => {
                                                            if (e.target.value > 0) {
                                                                const newProductos = [...productos];
                                                                newProductos[index].cantidad = e.target.value;
                                                                setProductos(newProductos);
                                                            }
                                                        }}
                                                        disabled={loading || !editing}/>
                                                    </Form.Group>
                                                </td>
                                                <td>
                                                    <Button className='mx-1' disabled={loading || !editing} variant="danger"
                                                    onClick={() => {
                                                        const newProductos = [...productos];
                                                        newProductos.splice(index, 1);
                                                        setProductos(newProductos);
                                                    }}>
                                                        X
                                                    </Button>
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </Table>
                            <Row className="m-2">
                                <Col xs={6}>
                                    <Form.Group className="mb-3" id="venta-crc">
                                        <Form.Label>Precio CRC</Form.Label>
                                        <Form.Control 
                                        type="number" 
                                        value={precioCRC}
                                        disabled={true}/>
                                    </Form.Group>
                                </Col>
                                <Col xs={6}>
                                    <Form.Group className="mb-3" id="venta-usd">
                                        <Form.Label>Precio USD</Form.Label>
                                        <Form.Control 
                                        type="number" 
                                        value={precioUSD}
                                        disabled={true}/>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='m-2'>
                                <Col xs={12}>
                                    <Button className='mx-1' disabled={loading || !editing} type="submit">
                                        Guardar
                                    </Button>
                                    <Button className='mx-1' disabled={loading || !editing} variant="danger"
                                    onClick={() => {setEditing(false); setEffect(effect+1)}}>
                                        Cancelar
                                    </Button>
                                    <Button className='m-1 py-0 px-1' disabled={loading || confirmada} variant="link" style={{fontSize: "1.65rem"}}
                                    onClick={() => {setEffect(effect+1); setEditing(true)}}>
                                        <span><FaEdit/></span>
                                    </Button>
                                    <Button className='m-1 py-0 px-1' disabled={loading} variant="link" style={{fontSize: "1.65rem"}}
                                    onClick={() => setShowDelete(true)}>
                                        <span><FaTrashAlt/></span>
                                    </Button>
                                </Col>
                            </Row>
                            <Row className='m-2'>
                                {!confirmada ?
                                    <Button className='mx-1' disabled={loading || editing} variant="success"
                                    onClick={() => setShowConfirmAlert(true)}>
                                        Confirmar Venta
                                    </Button>
                                :
                                    <CSVLink
                                    data={dataCSV}
                                    filename={`provell-orden-de-compra-${id}.csv`}
                                    className="btn btn-info mx-1"
                                    target="_blank"
                                    separator={";"}
                                    >
                                        Descargar .csv
                                    </CSVLink>

                                }                 
                            </Row>
                        </Form>
                    </Card.Body>
                </Card>
            </div>
        </Container>        
    )
}